enum COMPARED_TO_SETTINGS {
    'Chain Average' = 1,
    'Market Average',
}

export default COMPARED_TO_SETTINGS;
